import clsx from "clsx";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import styles from "./RadioButtons.module.scss";
import { Text } from "../Text/Text";

interface IRadioButtons {
  children: React.ReactNode;
  errorMessage?: string;
  icon?: React.ReactNode;
  legend?: string;
  description?: string;
  orientation?: "horizontal" | "vertical";
  width?: "hug-content" | "fill-container";
  size?: "default" | "compact";
}
const RadioButtons = ({
  children,
  errorMessage,
  icon,
  legend,
  description,
  orientation = "vertical",
  width = "hug-content",
  size = "default",
}: IRadioButtons) => {
  return (
    <fieldset className={styles.radioButtonsFieldset}>
      {icon || legend ? (
        <legend className={styles.legend}>
          {icon}
          {legend}
        </legend>
      ) : undefined}
      {description ? (
        <div className={styles.description}>
          <Text element="p" color="faded">
            {description}
          </Text>
        </div>
      ) : undefined}
      {errorMessage ? (
        <div className={clsx(styles.errorMessage, styles[`size-${size}`])}>
          <ErrorMessage message={errorMessage} weight="bold" />
        </div>
      ) : undefined}
      <div
        className={clsx(
          styles.radioButtons,
          styles[orientation],
          styles[`width-${width}`],
        )}
      >
        {children}
      </div>
    </fieldset>
  );
};

export default RadioButtons;
